import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { AoiService } from '../../../services/aoi.service';
import { GeocodeService } from '../../../services/geocode.service';
import { BaseComponent } from '../../base.component';
var AddressComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AddressComponent, _super);
    function AddressComponent(_vcr, geocodeService, aoiService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.geocodeService = geocodeService;
        _this.aoiService = aoiService;
        _this.debounceTime = 200;
        _this.maxSuggestionNumber = 10;
        _this.suggestions = [];
        _this.queryField = new FormControl();
        _this.activate = function () {
            if (_this.isActive) {
                return;
            }
            _this.queryField.valueChanges.pipe(debounceTime(_this.debounceTime), distinctUntilChanged(), switchMap(function (query) {
                if (!query || _this.searchCriteria && query === _this.searchCriteria.address) {
                    return;
                }
                _this.searchCriteria = null;
                return _this.geocodeService.suggest(query, _this.maxSuggestionNumber);
            })).subscribe(function (result) {
                if (result) {
                    _this.suggestions = result.suggestions;
                }
            });
            _this.isActive = true;
        };
        _this.reset = function () {
            _this.queryField.reset();
            _this.searchCriteria = null;
            _this.suggestions = [];
        };
        _this.addResultToMap = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.searchCriteria) {
                    this.aoiService.setSearchCriterias([this.searchCriteria]);
                }
                this.reset();
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    AddressComponent.prototype.selectResult = function (suggestion) {
        this.searchCriteria = {
            type: 'address',
            address: suggestion.text,
            magicKey: suggestion.magicKey
        };
        this.queryField.setValue(suggestion.text);
    };
    return AddressComponent;
}(BaseComponent));
export { AddressComponent };
